import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current trader may open the single-game live trading view
 * (/live/:gameKey). Resolved relay-side (GET /api/trader/me → `liveGameAccess`,
 * from traderRules.liveGameEnabled — fail-closed) and threaded onto the session
 * by refreshMe(). Defaults to false so the surface never leaks before access
 * lands. View exposure only — the order route independently enforces
 * one-click/LT2 capability on every order.
 */
export function useLiveGameAccess(): boolean {
  return useAuthStore((s) => s.user?.liveGameAccess ?? false);
}
